<template>
  <b-tabs content-class="mt-3">
    <b-tab v-for="(plan, idx) in planes" :key="plan.id" :title="plan.nombre" :active="idx == 0">
      <table class="table TablaModulosEdicionPrecios">
        <tbody>
          <tr valign="middle" class="labelDivisas">
            <td>&nbsp;</td>
            <td v-for="divisa in divisas" :key="divisa.id" :title="divisa.nombre">
              {{ divisa.abreviatura }}
            </td>
          </tr>

          <tr v-if="mostrarSuscripcion">
            <td>Suscripción</td>
            <td v-for="divisa in divisas" :key="divisa.id" :title="divisa.nombre">
              <b-form-input type="number" v-model="precios[plan.id][divisa.id]['precioSuscripcion']" />
            </td>
          </tr>

          <tr v-if="mostrarCuota">
            <td>Cuota Anual</td>
            <td v-for="divisa in divisas" :key="divisa.id" :title="divisa.nombre">
              <b-form-input
                v-model="precios[plan.id][divisa.id]['precioCuotaAnual']"
                type="number"
                placeholder="Precio Anual" />
            </td>
          </tr>

          <tr v-if="mostrarServicio">
            <td>Servicio</td>
            <td v-for="divisa in divisas" :key="divisa.id" :title="divisa.nombre">
              <b-form-input
                v-model="precios[plan.id][divisa.id]['precioServicio']"
                type="number"
                placeholder="Precio Servicio"
              />
            </td>
          </tr>
        </tbody>
      </table>
    </b-tab>
  </b-tabs>
</template>

<script>
import * as TipoModulo from "@/enums/TipoModulo";

export default {
  props: {
    modulo: Object,
    divisas: Array,
    planes: Array,
    tarifa: Object,
    precios: Object,
  },
  computed: {
    mostrarCuota() {
      return this.modulo.tipo != TipoModulo.SERVICIO;
    },
    mostrarSuscripcion() {
      return this.modulo.tipo != TipoModulo.SERVICIO;
    },
    mostrarServicio() {
      return this.modulo.tipo == TipoModulo.SERVICIO;
    },
  },
};
</script>
